import React, { useEffect, useState } from 'react';
import MuiButton from '@mui/material/Button';

const getColorBackwardsCompatible = ({ color, type }) => {
  if (color) return color;
  switch (type) {
    case 'BLUE':
    case 'WHITE_BLUE':
      return 'primary';
    case 'RED':
    case 'WHITE_RED':
      return 'error';
    case 'GREEN':
    case 'WHITE_GREEN':
      return 'success';
    default:
      return 'primary';
  }
};

const getSizeBackwardsCompatible = (size) => size?.toLowerCase();

const getVariantBackwardsCompatible = ({ type, variant }) => {
  if (variant) return variant;
  return type?.startsWith('WHITE_') ? 'outlined' : 'contained';
};

/**
 * @class Button
 * @classdesc Reusable button component
 * @property {Object} state
 * @property {(number|Function)} timeout
 * @example ./Button.md
 */
const Button = (props) => {
  const {
    children,
    classes,
    className,
    click,
    color,
    component,
    disabled,
    endIcon,
    loading,
    onClick,
    size,
    startIcon,
    style,
    svg,
    svgLeft,
    svgRight,
    sx,
    text = '',
    to,
    type,
    variant,
  } = props;

  const [bcColor, setBcColor] = useState();
  const [bcSize, setBcSize] = useState();
  const [bcVariant, setBcVariant] = useState();

  useEffect(() => {
    setBcColor(getColorBackwardsCompatible({ color, type }));
  }, [color, type]);

  useEffect(() => {
    setBcSize(getSizeBackwardsCompatible(size));
  }, [size]);

  useEffect(() => {
    setBcVariant(getVariantBackwardsCompatible({ type, variant }));
  }, [type, variant]);

  return (
    <MuiButton
      component={component}
      className={className}
      classes={classes}
      onClick={onClick ?? click}
      sx={sx ?? style}
      disabled={disabled}
      startIcon={startIcon ?? svgLeft ? svg : undefined}
      endIcon={endIcon ?? svgRight ? svg : undefined}
      color={bcColor}
      variant={bcVariant}
      size={bcSize}
      to={to}
      loading={loading}
    >
      {children ?? text}
    </MuiButton>
  );
};

export default Button;
